import EditableTable from '@/components/Table/EditableTable'
import { TooltipCell } from '@/components/Table/components/Cell'
import { createQuotationDetailUpdateHandler } from '@/features/offers/offer-detail/helper/quotationDetailExcel.helper'
import useZZZ6 from '@/features/zzz6/useZZZ6'
import { createColumnHelper } from '@tanstack/react-table'
import { useCallback, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { CostBudgetType } from '@eapproval/offer-shared'
import { getQuotationTemplateDetailColumns } from '../../../OfferSourcingTab/CostBudget/quotationTeamplateDetailColumns'

const PRSubmissionDetailTable = ({
  submissionPath,
  costBudgetType,
  canEditPRSubmissionTable,
  canEditPRSubmissionQuantity,
  handleOpenECCNDetailModel,
}) => {
  const { getValues, setValue } = useFormContext()
  const columnHelper = createColumnHelper()
  const requestedDetailsPath = `${submissionPath}.requestedDetails`
  const { useFetchZZZ6CategoryOptions, useFetchAllZZZ6s } = useZZZ6()

  const currency = useWatch({ name: `${submissionPath}.currency` }) ?? ''
  const requestedDetails = useWatch({ name: requestedDetailsPath }) ?? []
  const { data: zzz6Response } = useFetchAllZZZ6s({
    page: 1,
    pageSize: 100000,
    filters: { status: 'active' },
  })
  const { data: categoryOptions = [] } = useFetchZZZ6CategoryOptions({
    page: 1,
    pageSize: 100000,
    filters: { status: 'active' },
  })

  const handleUpdateTableData = useCallback(
    createQuotationDetailUpdateHandler({
      disabled: false,
      setValue,
      getValues,
      zzz6Response,
      costBudgetType,
      getRowPath: (rowIndex) => `${requestedDetailsPath}.${rowIndex}`,
      onAfterUpdate: ({ columnId, getValues: getFormValues, setValue: setFormValue }) => {
        if (columnId !== 'quantity') {
          return
        }

        const requestedDetails = getFormValues(requestedDetailsPath) ?? []
        const newTotalAmount = Array.isArray(requestedDetails)
          ? requestedDetails.reduce((acc, row) => {
              const quantity = row?.quantity ?? 0
              const unitRate = row?.unitRate ?? 0
              const discount = row?.discount ?? 0
              const lumpSumDiscount = row?.lumpSumDiscount ?? 0

              return acc + quantity * (unitRate * (1 - discount / 100) - lumpSumDiscount)
            }, 0)
          : 0

        setFormValue(`${submissionPath}.totalAmount`, newTotalAmount, {
          shouldDirty: true,
        })
      },
    }),
    [costBudgetType, getValues, requestedDetailsPath, setValue, submissionPath, zzz6Response]
  )

  const isCategoryDisabled = [
    CostBudgetType.SUPPLY_ENGINEERING_SERVICE,
    CostBudgetType.SUPPLY_MAINTENANCE_SERVICE,
  ].includes(costBudgetType)

  const editableColumnIds = useMemo(
    () => [
      ...(true ? ['quantity'] : []),
      ...(canEditPRSubmissionTable
        ? [...(isCategoryDisabled ? [] : ['category']), 'AL', 'ECCN', 'country', 'ECCNDetail', 'HSCode']
        : []),
    ],
    [canEditPRSubmissionQuantity, canEditPRSubmissionTable, isCategoryDisabled]
  )

  const requestedDetailsColumns = useMemo(
    () =>
      getQuotationTemplateDetailColumns({
        costBudgetType,
        isTemplate: false,
        canRemove: false,
        categoryOptions,
        disableCategory: false,
        editableColumnIds,
        handleOpenECCNDetailModel,
        currency,
      }),
    [categoryOptions, costBudgetType, editableColumnIds, handleOpenECCNDetailModel, currency]
  )

  const columnDef = useMemo(
    () => [
      columnHelper.display({
        id: 'vendorHistoryIndex',
        size: 10,
        header: () => <span>ref</span>,
        cell: ({ row: { index } }) => <TooltipCell text={index + 1} />,
      }),
      ...requestedDetailsColumns,
    ],
    [requestedDetailsColumns]
  )

  return (
    <EditableTable
      textAlign={'center'}
      columnDef={columnDef}
      data={requestedDetails}
      tableWidth="100%"
      disabled={false}
      updateData={handleUpdateTableData}
    />
  )
}

export default PRSubmissionDetailTable
